import { PLAN_MANAGER_BASE_ROUTE } from '@app/plan-manager/plan-manager.routes';

export interface INavigationItem {
  id: NavigationItemIdEnum;
  title: string;
  isActive: boolean;
  icons: {
    default: string;
    active: string;
  };
}

export enum NavigationItemIdEnum {
  MENU = 1,
  SEARCH,
  HOME,
  STATEMENT,
  PROFILE
}

export enum MobileBottomNavigationRoutesEnum {
  STATEMENT = '/plan/',
  PLAN_MANAGER = `/${PLAN_MANAGER_BASE_ROUTE}/`,
  SEARCH = '/search'
}
